// Aperte — răsfoirea pozelor cu degetul pe cardurile de produs (doar mobil).
//
// Derularea în sine e a browserului (scroll-snap din aperte-card-swipe.css).
// Aici stau doar cele trei lucruri pe care CSS-ul nu le poate face:
//   1. punctulețele care arată la a câta poză ești
//   2. atingerea scurtă pe poză = deschide produsul (tragerea nu)
//   3. clic pe un swatch de culoare = sari la poza acelei culori
(function () {
  // Snippetul e randat de mai multe secțiuni; eticheta <script> se poate
  // repeta, iar browserul o execută o dată pentru fiecare. Fără paza asta,
  // ascultătorii s-ar lega de două ori și o atingere ar naviga de două ori.
  if (window.aperteCardSwipeInit) return;
  window.aperteCardSwipeInit = true;

  var mq = window.matchMedia('(max-width: 749px)');

  function isMobile() {
    return mq.matches;
  }

  function trackOf(el) {
    return el && el.closest ? el.closest('.card__media .media--hover-effect') : null;
  }

  // --- 0. pozele 3-5 se descarcă abia la primul contact cu fâșia ------------
  //
  // Ele vin din Liquid cu adresele în `data-src` / `data-srcset` și fără `src`,
  // deci până aici nu costă nimic. Momentul ales e `pointerdown`, adică în clipa
  // în care degetul atinge poza — cu vreo 200-300 ms înainte ca swipe-ul să se
  // termine, deci de obicei poza e gata când ajunge pe ecran.
  //
  // `loading="lazy"` singur nu ajungea: măsurat, pozele ascunse tot ajungeau
  // cerute de browser.
  function hydrate(track) {
    if (!track || track.aperteHydrated) return;
    track.aperteHydrated = true;

    var slides = track.querySelectorAll('.aperte-card-slide--extra');
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i];
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
    }
  }

  // --- 1. punctulețele urmăresc poza vizibilă -------------------------------

  function updateDots(track) {
    var media = track.closest('.card__media');
    if (!media) return;
    var dots = media.querySelectorAll('.aperte-card-dot');
    if (!dots.length) return;

    var width = track.clientWidth || 1;
    var index = Math.round(track.scrollLeft / width);
    if (index < 0) index = 0;
    if (index > dots.length - 1) index = dots.length - 1;

    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === index);
    }
  }

  // `scroll` nu urcă prin bule, deci delegarea are nevoie de faza de captare.
  // Un cadru de animație per fâșie, altfel se recalculează la fiecare pixel.
  document.addEventListener(
    'scroll',
    function (e) {
      var track = e.target;
      if (!track.classList || !track.classList.contains('media--hover-effect')) return;
      hydrate(track);
      if (track.aperteRaf) return;
      track.aperteRaf = requestAnimationFrame(function () {
        track.aperteRaf = null;
        updateDots(track);
      });
    },
    true
  );

  // --- 2. atingere scurtă pe card = deschide produsul, tragere = nu ----------
  //
  // Stratul de link care acoperea tot cardul are acum `pointer-events: none`
  // (vezi CSS), altfel degetul n-ar ajunge niciodată la fâșie. Rolul lui îl
  // preia codul de aici: orice atingere scurtă pe card duce la produs, iar
  // tragerea nu — se deosebesc după distanța parcursă de deget.
  //
  // Sunt lăsate în pace lucrurile care au treaba lor: swatch-urile de culoare,
  // butonul „+" și linkurile adevărate (titlul), care navighează singure.

  var startX = 0;
  var startY = 0;
  var startTime = 0;
  var dragged = false;

  function reset() {
    startTime = 0;
    dragged = false;
  }

  function interactiv(target) {
    if (!target || !target.closest) return true;
    return !!target.closest('a, button, .aperte-card-swatch, .quick-add, product-form');
  }

  // Linkul produsului. Cardul standard din Dawn are două titluri — unul ascuns,
  // în interiorul lui `.card__inner`, care dă stratul de link, și cel vizibil.
  // Amândouă duc la același produs, dar cerem explicit un `href` de produs, ca
  // să nu depindem de ordinea din DOM.
  function linkProdus(card) {
    var links = card.querySelectorAll('.card__heading a[href]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('href')) return links[i];
    }
    return null;
  }

  document.addEventListener(
    'pointerdown',
    function (e) {
      if (!isMobile()) return;
      if (!e.target.closest || !e.target.closest('.card-wrapper')) return;

      // Pozele 3-5 se cer de la server abia acum, la primul contact cu fâșia.
      var track = trackOf(e.target);
      if (track) hydrate(track);

      startX = e.clientX;
      startY = e.clientY;
      startTime = Date.now();
      dragged = false;
    },
    { passive: true }
  );

  document.addEventListener(
    'pointermove',
    function (e) {
      if (!startTime || dragged) return;
      if (Math.abs(e.clientX - startX) > 8 || Math.abs(e.clientY - startY) > 8) dragged = true;
    },
    { passive: true }
  );

  document.addEventListener('pointercancel', reset, { passive: true });

  document.addEventListener(
    'pointerup',
    function (e) {
      if (!startTime) return;
      var quick = Date.now() - startTime < 600;
      var wasDragged = dragged;
      reset();
      if (wasDragged || !quick || !isMobile()) return;
      if (interactiv(e.target)) return;

      var card = e.target.closest && e.target.closest('.card-wrapper');
      if (!card) return;
      var link = linkProdus(card);
      if (link) link.click();
    },
    { passive: true }
  );

  // --- 3. swatch-ul de culoare sare la poza lui -----------------------------
  //
  // Chemată din aperte-card-swatches.js. Întoarce true doar dacă poza culorii
  // chiar există în fâșie; altfel acela rămâne pe comportamentul vechi, adică
  // înlocuiește poza principală a cardului.
  window.aperteSwipeJumpToMedia = function (card, mediaId) {
    if (!isMobile() || !card || !mediaId) return false;

    var track = card.querySelector('.card__media .media--hover-effect');
    if (!track) return false;

    hydrate(track);

    var slides = track.querySelectorAll('img');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].dataset.mediaId === String(mediaId)) {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        return true;
      }
    }
    return false;
  };
})();
